import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output
} from '@angular/core';
import { Invoice, Payment } from '@models/invoice.model';

@Component({
	selector: 'invoice-payments-schedule-table',
	template: require('./invoice-payments-schedule-table.html'),
	styles: [require('./invoice-payments-schedule-table.scss')]
})
export class InvoicePaymentsScheduleTable implements OnInit, OnChanges {
	@Input('data') invoice: Invoice;
	@Input() shouldHaveActions: boolean;
	@Input() currencySymbol: boolean;
	@Input() spinners;
	@Input() showHeader = true;
	@Output() setPaidEmitter: EventEmitter<Payment> = new EventEmitter();
	@Output() payOnlineEmitter: EventEmitter<void> = new EventEmitter();
	@Output() setUnpaidEmitter: EventEmitter<Payment> = new EventEmitter();
	@Output() writeOffEmitter: EventEmitter<Payment> = new EventEmitter();
	@Output() undoWriteOffEmitter: EventEmitter<Payment> = new EventEmitter();
	@Output() sendReceiptEmitter: EventEmitter<any> = new EventEmitter();

	public payments: Array<Payment> = [];
	public writtenOffPayments: Array<Payment> = [];

	constructor() {}

	ngOnInit(): void {
		this.mapPayments(this.invoice.payments);
	}

	ngOnChanges(change): void {
		this.mapPayments(change.invoice.currentValue.payments);
	}

	public setPaid(payment: Payment): void {
		this.setPaidEmitter.emit(payment);
	}

	public payOnline(): void {
		this.payOnlineEmitter.emit();
	}

	public showWriteOff(payment: Payment): void {
		this.writeOffEmitter.emit(payment);
	}

	public undoOff(payment: Payment): void {
		this.undoWriteOffEmitter.emit(payment);
	}

	public setUnpaid(payment: Payment): void {
		this.setUnpaidEmitter.emit(payment);
	}

	public showSendInvoice(payment: Payment): void {
		this.sendReceiptEmitter.emit({
			isReceipt: true,
			data: payment,
			invoice: this.invoice
		});
	}

	public calculateDaysToPay(payment: Payment): string {
		let result = '';
		if (!payment.paid) {
			// Check If we have negative number to decide how to show status
			const isPast = payment.daysLeftForPayment.toString().charCodeAt(0) === 45;
			const isToday = payment.daysLeftForPayment === 0;
			const days =
				payment.daysLeftForPayment === 1 || payment.daysLeftForPayment === -1
					? ' day'
					: 'days';

			if (isToday) {
				result = '(today)';
			} else if (isPast) {
				result = `(${payment.daysLeftForPayment
					.toString()
					.slice(1)} ${days} ago)`;
			} else {
				result = `(in ${payment.daysLeftForPayment} ${days})`;
			}
		}

		return result;
	}

	public getDueDateCorrectColor(payment): string {
		// Check If we have negative number to decide how to show status
		const isPast = payment.daysLeftForPayment.toString().charCodeAt(0) === 45;
		if (isPast) {
			return 'color-froly-dark';
		}
	}

	private mapPayments(payments: Array<Payment>): void {
		this.payments = [];
		this.writtenOffPayments = [];
		payments.map(e => {
			e.writtenOff ? this.writtenOffPayments.push(e) : this.payments.push(e);
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.ts